import { SolicitanteService } from 'src/app/services/solicitante/solicitante.service';
import { HistorialService } from './../../services/historial.service';
import { Pescador } from 'src/app/models/pescador';
import {MatDialog, MatDialogConfig} from '@angular/material';
import { ReciboComponent } from '../recibo/recibo.component';
import { FileService } from 'src/app/services/file.service';
import {saveAs} from 'file-saver';
import { Subscription } from 'rxjs/Subscription';



import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';

import * as XLSX from 'xlsx';

import {Router} from '@angular/router';
import { EditorComponent } from './../editor/editor.component';
import { Licencia } from './../../models/licencia';
import { isNull } from 'util';


@Component({
  selector: 'app-historial',
  templateUrl: './historial.component.html',
  styleUrls: ['./historial.component.css']
})
export class HistorialComponent implements OnInit, OnDestroy {

   finicial: Date;
   ffinal: Date;

   sumatoriacompraano=0;
   totalacumulado = 0;
   sumatoriadia = 0;
   sumatoriasemana = 0;
   sumatoriames = 0;
   sumatoriaano = 0;
   sumatoriaexcursion = 0;
   sumatotal = 0;
   sumalicenciaprepago = 0;
   visualizaarray = '';
   licdiaprecompra=0;

   licanoprecompra=0;
   licsemanaprecompra=0

   subscription: Subscription;



   tablacompletada = false;


 //  usuarioSeleccionado: Solicitante[];



  /*name of the excel-file which will be downloaded. */
  fileName = 'ExcelSheet.xlsx';
  nombreArchivo = '';
  licencia: Pescador[] = [];

  licencia2: Pescador[] = [];
  licenciaCompleta: Pescador[] = [];
  solicitantes: string[] = [];
  filtroSolicitante = 'todos';
  filtroReferencia = 'todos';
  ordenRegistros = 'ascendente';


  desde = 0;
  totalRegistro = 0;

  constructor(
    private licenciaServicio: HistorialService,
    private solicitanteService: SolicitanteService,
    private router: Router,
    private dialog: MatDialog,
    private _fileService: FileService,

    ) { }

  ngOnInit() {
   
   // this.cargarLicencias();
  }


  ngOnDestroy() {
    
}






regresaPrehistorial(listado) { 
  //  if (this.showPDF) {
  this.solicitanteService
    .reactivaSolicitud(listado.idregistro)
    .subscribe((res) => {
      
      alert ("accion Realizada")

      
    });

  //  } else {
  //   Swal.fire('Oops...', 'Creo que olvido subir el archivo', 'error');
  //  }
}



  cargarLicencias( finicial: Date, ffinal: Date) {
    this.finicial = finicial;
    this.ffinal = ffinal;
    this.totalacumulado = 0;
    this.sumatoriadia = 0;

    this.totalacumulado = 0;
    this.sumatoriacompraano = 0;
    this.sumatoriadia = 0;
    this.sumatoriasemana = 0;
    this.sumatoriames = 0;
    this.sumatoriaano = 0;
    this.sumatoriaexcursion = 0;
    this.sumatotal = 0;
    this.sumalicenciaprepago = 0;
    this.visualizaarray = '';

    this.subscription = this.licenciaServicio.getMuestraHistorial( this.desde, this.finicial, this.ffinal)
      .subscribe (licencia => {

        this.licenciaCompleta = licencia || [];
        this.solicitantes = Array.from(new Set(
          this.licenciaCompleta
            .filter(item => {
              const solicitante: any = item.idsolicitante;
              return solicitante && solicitante.nombre;
            })
            .map(item => {
              const solicitante: any = item.idsolicitante;
              return solicitante.nombre;
            })
        )).sort((a, b) => a.localeCompare(b));

        this.filtroSolicitante = 'todos';
        this.filtroReferencia = 'todos';
        this.ordenRegistros = 'ascendente';
        this.aplicarFiltros();
        console.log ("estas son las licencias",licencia);








        // this.sumalicenciaprepago = this.licencia.filter(item =>
        //   (item.tipolicencia.indexOf('Dia') !== -1 || item.tipolicencia.indexOf('dia') !== -1 || item.tipolicencia.indexOf('Day') !== -1)
        //   && (item.deprecompra) && (item.costolicencia === 0)
        // ).reduce((a, b) => a + b.cantidad, 0);




         this.sumatoriadia = this.licencia.filter(item =>
           (item.tipolicencia.indexOf('Dia') !== -1 || item.tipolicencia.indexOf('dia') !== -1 || item.tipolicencia.indexOf('Day') !== -1)
            && (item.costolicencia !== 0)
         ).reduce((a, b) => a + b.cantidad, 0);






        this.sumatoriasemana = this.licencia.filter(item =>
          (item.tipolicencia.indexOf('Week') !== -1 || item.tipolicencia.indexOf('Seman') !== -1 )
        ).reduce((a, b) => a + b.cantidad, 0);




        this.sumatoriames = this.licencia.filter(item =>
          (item.tipolicencia.indexOf('Month') !== -1 || item.tipolicencia.indexOf('Mes') !== -1 )
        ).reduce((a, b) => a + b.cantidad, 0);


        console.log ("***********************aqui s einicial elproceso aniual");

         this.sumatoriaano = this.licencia.filter(item =>
          
           (item.tipolicencia.indexOf('Year') !== -1 || item.tipolicencia.indexOf('Año') !== -1  || item.tipolicencia.indexOf('año') !== -1 )
           && (item.costolicencia !== 0)
         ).reduce((a, c) => a + c.cantidad, 0);


         this.sumatoriaexcursion = this.licencia.filter(item =>
          
          (item.tipolicencia.indexOf('Excursion') !== -1)
          && (item.costolicencia !== 0)
        ).reduce((a, c) => a + c.cantidad, 0);



        // muestracostolicenciadia(listado: Pescador) {
        //   if (((listado.tipolicencia.indexOf ('Day') !== -1) || (listado.tipolicencia.indexOf ('dia') !== -1) ||
        //   (listado.tipolicencia.indexOf ('Dia') !== -1)) && (listado.costolicencia == 0 )  ) {
        //     return listado.cantidad;
        //   } else {
        //     return '-';
        //  }
        
        // }
        
        

        this.licdiaprecompra = this.licencia.filter(item =>
          
          (item.tipolicencia.indexOf('Day') !== -1) || (item.tipolicencia.indexOf('dia') !== -1) || (item.tipolicencia.indexOf('Dia') !== -1)
          && (item.costolicencia == 0)
        ).reduce((a, c) => a + c.cantidad, 0);



        this.licsemanaprecompra = this.licencia.filter(item =>
          
          (item.tipolicencia.indexOf('Week') !== -1) || (item.tipolicencia.indexOf('Seman') !== -1) 
          && (item.costolicencia == 0)
        ).reduce((a, c) => a + c.cantidad, 0);




        this.licanoprecompra = this.licencia.filter(item =>
          
          (item.tipolicencia.indexOf('Year') !== -1) || (item.tipolicencia.indexOf('Año') !== -1) || (item.tipolicencia.indexOf('año') !== -1)
          && (item.costolicencia == 0)
        ).reduce((a, c) => a + c.cantidad, 0);



        // var resSet=this.licencia.filter((options) => (options.tipolicencia.indexOf('Dia') !== -1
        //  options.tipolicencia.indexOf('dia') !== -1 || options.tipolicencia.indexOf('Day') !== -1)).reduce((a, b) => a + b.cantidad, 0);


        // var resSet=this.licencia.filter((options) => options.tipolicencia.indexOf('Dia') !== -1
        // .reduce((a, b) => a + b.cantidad, 0);







      //   this.sumatoriasemana  = this.licencia.reduce(function(sum, value) {
      //     if ((value.tipolicencia.indexOf ('Week') !== -1) || (value.tipolicencia.indexOf ('Seman') !== -1)) {
      //     return sum + value.cantidad;
      //   }
      // }, 1);


    //   this.sumatoriames  =  this.sumatoriames + this.licencia.reduce(function(sum, value) {
    //     if ((value.tipolicencia.indexOf ('Month') !== -1) || (value.tipolicencia.indexOf ('Mes') !== -1)) {
    //     return value.cantidad;
    //   }
    // }, 1);
















      });
  }


  aplicarFiltros() {
    let registros = this.licenciaCompleta.filter(item => {
      const solicitante: any = item.idsolicitante;
      return solicitante && solicitante.numeroconfirmacion !== null;
    });

    if (this.filtroSolicitante !== 'todos') {
      registros = registros.filter(item => {
        const solicitante: any = item.idsolicitante;
        return solicitante.nombre === this.filtroSolicitante;
      });
    }

    if (this.filtroReferencia !== 'todos') {
      registros = registros.filter(item => {
        const solicitante: any = item.idsolicitante;
        return this.clasificaReferencia(solicitante.numeroconfirmacion) === this.filtroReferencia;
      });
    }

    registros.sort((a, b) => {
      const solicitanteA: any = a.idsolicitante;
      const solicitanteB: any = b.idsolicitante;
      const ordenA = solicitanteA.numeroperacion || '';
      const ordenB = solicitanteB.numeroperacion || '';
      const comparacion = ordenA.localeCompare(ordenB, undefined, {numeric: true});
      return this.ordenRegistros === 'descendente' ? -comparacion : comparacion;
    });

    this.licencia = registros;
    this.totalRegistro = registros.length;
    this.recalcularTotales();
  }


  clasificaReferencia(referencia: string) {
    const valor = (referencia || '').trim().toLowerCase();

    if (valor.indexOf('payid') === 0) {
      return 'paypal';
    }

    if (valor.indexOf('tranf') === 0 || valor.indexOf('trans') === 0) {
      return 'transferencia';
    }

    if (valor.indexOf('precompra') !== -1) {
      return 'precompra';
    }

    return 'otros';
  }


  recalcularTotales() {
    this.sumatoriadia = this.licencia.filter(item =>
      (item.tipolicencia.indexOf('Dia') !== -1 || item.tipolicencia.indexOf('dia') !== -1 || item.tipolicencia.indexOf('Day') !== -1)
      && item.costolicencia !== 0
    ).reduce((a, b) => a + b.cantidad, 0);

    this.sumatoriasemana = this.licencia.filter(item =>
      item.tipolicencia.indexOf('Week') !== -1 || item.tipolicencia.indexOf('Seman') !== -1
    ).reduce((a, b) => a + b.cantidad, 0);

    this.sumatoriaano = this.licencia.filter(item =>
      (item.tipolicencia.indexOf('Year') !== -1 || item.tipolicencia.indexOf('Año') !== -1 || item.tipolicencia.indexOf('año') !== -1)
      && item.costolicencia !== 0
    ).reduce((a, b) => a + b.cantidad, 0);

    this.sumatoriaexcursion = this.licencia.filter(item =>
      item.tipolicencia.indexOf('Excursion') !== -1 && item.costolicencia !== 0
    ).reduce((a, b) => a + b.cantidad, 0);

    this.licdiaprecompra = this.licencia.filter(item =>
      (item.tipolicencia.indexOf('Day') !== -1 || item.tipolicencia.indexOf('dia') !== -1 || item.tipolicencia.indexOf('Dia') !== -1)
      && item.costolicencia == 0
    ).reduce((a, b) => a + b.cantidad, 0);

    this.licsemanaprecompra = this.licencia.filter(item =>
      (item.tipolicencia.indexOf('Week') !== -1 || item.tipolicencia.indexOf('Seman') !== -1)
      && item.costolicencia == 0
    ).reduce((a, b) => a + b.cantidad, 0);

    this.licanoprecompra = this.licencia.filter(item =>
      (item.tipolicencia.indexOf('Year') !== -1 || item.tipolicencia.indexOf('Año') !== -1 || item.tipolicencia.indexOf('año') !== -1)
      && item.costolicencia == 0
    ).reduce((a, b) => a + b.cantidad, 0);
  }



  //  cambiarDesde( valor: number) {

  //    const desde = this.desde + valor;
  //    console.log (desde);

  // //    if ( desde >= this.totalRegistro ) {
  // //      return;

  // //    }


  // //    if ( desde < 0 ) {
  // //      return;
  // //  }

  //    this.desde += valor;

  //    this.licenciaServicio.getMuestraHistorial( this.desde, this.finicial, this.ffinal)
  //     .subscribe (licencia => {
  //       this.totalRegistro = this.licenciaServicio.totalRegistro;
  //       this.licencia = licencia;


  //       // this.sumatoriadia = this.licencia.reduce((
  //       //   acc,
  //       //   obj,
  //       // ) => acc + (obj.cantidad),
  //       // 0);


  //     });






  //  }



      despliegatablafecha(event) {

        console.log ('qui se vuelve  ejecutar');
        this.cargarLicencias(event.iniciofecha, event.finfecha);




   }


      exportexcel(): void{
      /* table id is passed over here */
      const element = document.getElementById('excel-table');
      const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(wb, this.fileName);

   }


   calculacostoLicencia(listado){
     return   listado.costolicencia / listado.cantidad ;
   }

   reactivaRegistros(cveregistro){



    this.solicitanteService.reactivaSolicitud( cveregistro )
     .subscribe( res => {

     }
     );




   }


estadisticas() {
  console.log ('esta licencia viene dle historial', this.licencia)
  this.router.navigate(['/graficolineal', this.licencia]);
}



reimprimirTicket(event){
  console.log ("info",event);
  localStorage.setItem('idseleccionsolicitante', event.idsolicitante._id);

  this.dialog.open(ReciboComponent, { disableClose: true });
  // let misDatos = JSON.parse( localStorage.getItem('usuario') );
  // let titulo = misDatos.role;
  // alert (titulo);


}



visualizaEdito(event){
 // console.log ("info",event);
  localStorage.setItem('idseleccionsolicitante', event.idsolicitante._id);

  this.dialog.open(EditorComponent, { disableClose: true });
  // let misDatos = JSON.parse( localStorage.getItem('usuario') );
  // let titulo = misDatos.role;
  // alert (titulo);


}



download(usuarioSeleccionado ) {

  console.log (usuarioSeleccionado);

 // alert (this.event.idsolicitante.nombreArchivo);
 // console.log (this.event.idsolicitante.nombreArchivo);

  this._fileService.downloadFileExcel(usuarioSeleccionado)
   .subscribe(
       data => saveAs(data, usuarioSeleccionado),
       error => console.error(error)
   );
}

muestracompralicenciadia(listado: Pescador) {
  if (((listado.tipolicencia.indexOf ('Day') !== -1) || (listado.tipolicencia.indexOf ('Dia') !== -1)) && (listado.costolicencia != 0) ) {
    return listado.cantidad;
  } else {
    return '-';
 }

}

muestracostolicenciadia(listado: Pescador) {
  if (((listado.tipolicencia.indexOf ('Day') !== -1) || (listado.tipolicencia.indexOf ('dia') !== -1) ||
  (listado.tipolicencia.indexOf ('Dia') !== -1)) && (listado.costolicencia == 0 )  ) {
    return listado.cantidad;
  } else {
    return '-';
 }

}


muestracompralicenciasemana(listado: Pescador){
  if ((listado.tipolicencia.indexOf ('Week') !== -1) || (listado.tipolicencia.indexOf ('Seman') !== -1) && (listado.costolicencia!=0)) {
    return listado.cantidad;
  } else {
     return '-';
  }

}




muestracostolicenciasemana(listado: Pescador){
  if (((listado.tipolicencia.indexOf ('Week') !== -1) || (listado.tipolicencia.indexOf ('Seman') !== -1)) && (listado.costolicencia==0)){
    return listado.cantidad;
  } else {
     return '-';
  }

}




muestracostolicenciames(listado: Pescador){
  if ((listado.tipolicencia.indexOf ('Month') != -1) || (listado.tipolicencia.indexOf ('Mes') != -1) || (listado.tipolicencia.indexOf ('mes') != -1)) {
    if (listado.costolicencia == 0) {
      return listado.cantidad;
   // this.sumatoriames = this.sumatoriames + listado.cantidad;
    }
    

  } else {
     return '-';
  }

}

muestracompralicenciaano(listado: Pescador){
  if ((listado.tipolicencia.indexOf ('Year') != -1) || (listado.tipolicencia.indexOf ('Año') != -1) || (listado.tipolicencia.indexOf ('año') != -1)) {
    if ((listado.costolicencia != 0) && (listado.costolicencia != null)) {
   
   return listado.cantidad;
    }
    
  } else {
     return '-';
  }

}

muestracostolicenciaano(listado: Pescador){
  if ((listado.tipolicencia.indexOf ('Year') != -1) || (listado.tipolicencia.indexOf ('Año') != -1) || (listado.tipolicencia.indexOf ('año') != -1)) {
    if (listado.costolicencia != 0) {
    
   return listado.cantidad;
    } else {
      return '-';
    }
   
  } else {
     return '-';
  }

}

muestracostolicenciaexcursion(listado: Pescador){
  if (listado.tipolicencia.indexOf ('Excur') !== -1)  {
    if (listado.cantidad !== null) {

      // this.sumatoriaexcursion = Number(this.sumatoriaexcursion) +  Number(listado.cantidad);


      return listado.cantidad;
  } else {
     return '-';
  }

}





//   grantotalacumulativo(listado: Pescador) {
//   this.totalacumulado = this.totalacumulado + listado.costolicencia ;
//   return this.totalacumulado;
 }



 muestraobservaciones(listado: Pescador){
  
    if (listado.observaciones !== null) {

    //  this.sumatoriaexcursion = Number(this.sumatoriaexcursion) +  Number(listado.cantidad);


      return listado.observaciones;
  } else {
     return '-';
  }


 }

 muestramovimientoprecompra(listado: Pescador){
  if (((listado.tipolicencia.indexOf ('Day') !== -1) || (listado.tipolicencia.indexOf ('dia') !== -1) ||
  (listado.tipolicencia.indexOf ('Dia') !== -1)) && (listado.deprecompra) && (listado.costolicencia == 0)) {
   console.log ('precompra');
   return listado.cantidad;
  } else {
    return '-';
 }
}

mensaje(){
  alert ('fin');
}


ultimalinea(ultimalinea: boolean) {
  if (ultimalinea) {
   // this.subscription.unsubscribe();
  }
}

}
